import React from 'react';
import '../LegalPages.css';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
const PoliticaDePrivacidade = () => {
  return (
    <div className="legal-page-container">
      <h1>Política de Privacidade</h1>
      <p><strong>Última atualização:</strong> 21 de Agosto de 2025</p>

      <h2>1. Introdução</h2>
      <p>A privacidade dos nossos visitantes é de extrema importância para o <strong>Hotel Alzira Plaza</strong> (referido como "nós"). Esta Política de Privacidade detalha como coletamos, utilizamos, armazenamos e protegemos os seus dados pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD).</p>

      <h2>2. Dados Pessoais Coletados</h2>
      <p>Coletamos os seguintes tipos de informações:</p>
      <ul>
        <li><strong>Informações fornecidas por você:</strong> Nome completo, CPF, RG, data de nascimento, endereço, e-mail, telefone e dados de pagamento ao realizar uma reserva.</li>
        <li><strong>Informações coletadas automaticamente:</strong> Endereço IP, tipo de navegador, páginas visitadas, tempo de permanência e outras informações através de cookies enquanto você navega em nosso site.</li>
      </ul>

      <h2>3. Finalidade da Coleta de Dados</h2>
      <p>Utilizamos seus dados para as seguintes finalidades:</p>
      <ul>
        <li>Processar, confirmar e gerenciar sua reserva e estadia.</li>
        <li>Realizar procedimentos de check-in e check-out.</li>
        <li>Cumprir obrigações legais e fiscais (ex: emissão de Nota Fiscal).</li>
        <li>Comunicar-nos com você sobre sua reserva ou para fins de suporte ao cliente.</li>
        <li>Melhorar a experiência em nosso website e personalizar nossos serviços.</li>
        <li>Enviar comunicações de marketing (como promoções e novidades), mediante seu consentimento expresso.</li>
      </ul>

      <h2>4. Compartilhamento de Dados</h2>
      <p>Não vendemos seus dados pessoais. Podemos compartilhar suas informações com:</p>
      <ul>
        <li><strong>Fornecedores de Serviços:</strong> Como gateways de pagamento e sistemas de gestão de reservas, que processam os dados em nosso nome.</li>
        <li><strong>Autoridades Governamentais:</strong> Em caso de obrigação legal ou requisição judicial.</li>
      </ul>

      <h2>5. Armazenamento e Segurança</h2>
      <p>Seus dados são armazenados em servidores seguros. Adotamos medidas técnicas e administrativas, como criptografia SSL, para proteger suas informações contra acesso não autorizado, alteração, destruição ou perda.</p>

      <h2>6. Seus Direitos como Titular dos Dados</h2>
      <p>De acordo com a LGPD, você tem o direito de:</p>
      <ul>
        <li>Confirmar a existência de tratamento de seus dados.</li>
        <li>Acessar seus dados.</li>
        <li>Corrigir dados incompletos, inexatos ou desatualizados.</li>
        <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários.</li>
        <li>Solicitar a portabilidade dos seus dados a outro fornecedor.</li>
        <li>Revogar o consentimento a qualquer momento.</li>
      </ul>
      <p>Para exercer seus direitos, entre em contato com nosso Encarregado de Proteção de Dados (DPO) através do e-mail: <strong>contato@alziraplazahotel.com.br</strong>.</p>
      
      <h2>7. Cookies</h2>
      <p>Utilizamos cookies para melhorar a funcionalidade do nosso site. Você pode gerenciar ou desativar os cookies através das configurações do seu navegador, porém, isso pode afetar a experiência de navegação.</p>

      <h2>8. Alterações nesta Política</h2>
      <p>Podemos atualizar esta Política de Privacidade periodicamente. A versão mais recente estará sempre disponível em nosso site, com a data da última atualização.</p>

<p className="company-info">
        <strong>ALZIRA PLAZA HOTEL</strong><br />
        CNPJ: 10.312.533/0001-62 <br />
        Endereço: Av. Dr. Getúlio Vargas, 31 - Centro, São Lourenço-MG<br />

        <a href="tel:+553533312970" className="whatsapp-link" target="_blank" rel="noopener noreferrer">
          <FaPhone />
          <span>(35) 3331-2970</span>

        </a>
        <br />
        <a href="https://wa.me/+5535988179138" className="whatsapp-link" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp />
          <span>Whatsapp</span>
        </a>
      </p>
    </div>
  );
};

export default PoliticaDePrivacidade;